import type { SVGProps } from 'react';
const SvgHomeChimney = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="-0.75 -0.75 20 20" {...props}>
    <desc>{'Home Chimney 1 Streamline Icon: https://streamlinehq.com'}</desc>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
      <path d="m.66 10.571 8.59-8.589 8.59 8.59" />
      <path d="M3.304 7.929v8.589h11.892V2.643h-3.303v1.982M9.25 12.554v3.964" />
    </g>
  </svg>
);
export default SvgHomeChimney;
